import React from "react";

// import public pages
import Landing from "components/Landing";
import Dashboard from "components/dashboard/Dashboard";
import PostsContainer from "components/posts/PostsContainer";
import CreatePostContainer from "components/posts/CreatePostContainer";
import VerifyAccountEmailContainer from "components/account/VerifyAccountEmailContainer";
import ResetPasswordLoginContainer from "components/account/ResetPasswordLoginContainer";
import LogoutContainer from "components/account/LogoutContainer";
import OnboardingContainer from "components/settings/OnboardingContainer";
import DiscoverContainer from "components/discover/DiscoverContainer";
import ChatContainer from "components/chat/ChatContainer";
import MessagesContainer from "components/chat/MessagesContainer";
import CreateChatContainer from "components/chat/CreateChatContainer";
import Referrals from "components/referrals/Referrals";
import Wallet from "components/wallet/Wallet";
import Settings from "components/settings/Settings";
import VerifyAddedEmailContainer from "components/account/VerifyAddedEmailContainer";
import Contest from "components/contest/Contest";
import UpdateProfileContainer from "components/settings/UpdateProfileContainer";
import MagicLoginContainer from "components/account/MagicLoginContainer";
import PrivacyPolicy from "components/PrivacyPolicy";
import Terms from "components/Terms";
import SuperLoginContainer from "components/account/SuperLoginContainer";
import DataDeletionStatusContainer from "components/account/DataDeletionStatusContainer";
import PromoLandingOne from "components/PromoLandingOne";
import PromoLandingEarn from "components/PromoLandingEarn";
import PromoLandingMLM from "components/PromoLandingMLM";
import CreatePostTutorialContainer from "components/posts/CreatePostTutorialContainer";
import Purchase from "components/purchaseCoins/Purchase";
import CreateTeamChatContainer from "components/chat/CreateTeamChatContainer";
import ConvertCoinsContainer from "components/convertCoins/ConvertCoinsContainer";
import AdPlanPage from "components/adPlan/AdPlanPage";
import AdvertisingPlansPage from "components/adPlan/AdvertisingPlansPage";
import ReviewAdPlanPage from "components/adPlan/ReviewAdPlanPage";
import ManageAdPlanPage from "components/adPlan/ManageAdPlanPage";
import SelectGoal from "components/SelectGoal";
import Pages from "components/pages/Pages";
import PageTemplates from "components/pages/PageTemplates";
import MarketingTools from "components/pages/MarketingTools";
import MailingLists from "components/pages/MailingLists";
import MailingList from "components/pages/MailingList";
import LeadDetailContainer from "components/pages/LeadDetailContainer";
import CreateMailingListContainer from "components/pages/CreateMailingListContainer";
import TelegramRewards from "components/telegramRewards/TelegramRewards";
import Autoresponders from "components/autoresponder/Autoresponders";
import Autoresponder from "components/autoresponder/Autoresponder";

// import protected pages
//import Landing from "../components/Landing";

const publicRoutes = [
  {
    path: "/",
    component: <Landing />,
  },
  {
    path: "/promo-one",
    component: <PromoLandingOne />,
  },
  {
    path: "/promo-earn",
    component: <PromoLandingEarn />,
  },
  {
    path: "/promo-mlm",
    component: <PromoLandingMLM />,
  },
  {
    path: "/verify-account-email",
    component: <VerifyAccountEmailContainer />,
  },
  {
    path: "/reset-password-login",
    component: <ResetPasswordLoginContainer />,
  },
  {
    path: "/verify-added-email",
    component: <VerifyAddedEmailContainer />,
  },
  {
    path: "/magic-login",
    component: <MagicLoginContainer />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    component: <Terms />,
  },
  {
    path: "/s-login",
    component: <SuperLoginContainer />,
  },
  {
    path: "/account-status",
    component: <DataDeletionStatusContainer />,
  },
];

const authProtectedRoutes = [
  {
    path: "/home",
    component: <Dashboard />,
  },
  {
    path: "/discover",
    component: <DiscoverContainer />,
  },
  {
    path: "/messages",
    component: <MessagesContainer />,
  },
  {
    path: "/posts",
    component: <PostsContainer />,
  },
  {
    path: "/modify-post",
    component: <CreatePostContainer />,
  },
  {
    path: "/logout",
    component: <LogoutContainer />,
  },
  {
    path: "/onboarding",
    component: <OnboardingContainer />,
  },
  {
    path: "/chat",
    component: <ChatContainer />,
  },
  {
    path: "/createchat",
    component: <CreateChatContainer />,
  },
  {
    path: "/referrals",
    component: <Referrals />,
  },
  {
    path: "/wallet",
    component: <Wallet />,
  },
  {
    path: "/settings",
    component: <Settings />,
  },
  {
    path: "/contest",
    component: <Contest />,
  },
  {
    path: "/updateprofile",
    component: <UpdateProfileContainer />,
  },
  {
    path: "/post-tutorial",
    component: <CreatePostTutorialContainer />,
  },
  {
    path: "/purchase-coins",
    component: <Purchase />,
  },
  {
    path: "/create-team-chat",
    component: <CreateTeamChatContainer />,
  },
  {
    path: "/convert-coins",
    component: <ConvertCoinsContainer />,
  },
  {
    path: "/ad-plan",
    component: <AdPlanPage />,
  },
  {
    path: "/advertising-plans",
    component: <AdvertisingPlansPage />,
  },
  {
    path: "/review-ad-plan",
    component: <ReviewAdPlanPage />,
  },
  {
    path: "/manage-ad-plan",
    component: <ManageAdPlanPage />,
  },
  {
    path: "/select-goal",
    component: <SelectGoal />,
  },
  {
    path: "/landing-pages",
    component: <Pages />,
  },
  {
    path: "/landing-page-templates",
    component: <PageTemplates />,
  },
  {
    path: "/marketing-tools",
    component: <MarketingTools />,
  },
  {
    path: "/mailing-lists",
    component: <MailingLists />,
  },
  {
    path: "/mailing-list",
    component: <MailingList />,
  },
  {
    path: "/lead-detail",
    component: <LeadDetailContainer />,
  },
  {
    path: "/create-mailing-list",
    component: <CreateMailingListContainer />,
  },
  {
    path: "/telegram-rewards",
    component: <TelegramRewards />,
  },
  {
    path: "/autoresponders",
    component: <Autoresponders />,
  },
  {
    path: "/autoresponder",
    component: <Autoresponder />,
  },
];

export { authProtectedRoutes, publicRoutes };
